import Cards from "../../../components/elements/Cards";
import Input from "../../../components/form/Input";
import Select from "../../../components/form/Select";
import DatePicker from "../../../components/form/DatePicker";
import Button from "../../../components/form/Button";
// import { countries } from "../../../../db/countries";
import {
  initialsValue,
  loadDataOnScroll,
  removeDuplicateFromArray,
} from "../../../helpers";

import { useEffect, useState } from "react";
import dayjs from "dayjs";
import AvatarUpload from "../../../components/common/AvatarUpload";
import useForm from "../../../hooks/useForm";
// import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";
import { userAddEdit, userDetails } from "../../../services/userService";
import Form from "../../../components/form/Form";
// import { countryList } from "../../../../services/countryService";
// import { languageList } from "../../../../services/LanguageService";
import PhoneNumberInput from "../../../components/form/PhoneNumberInput";
// import { SOCIAL_MEDIA } from "../../../constant/constant";
import Badge from "../../../components/elements/Badge";
import Image from "../../../components/elements/Image";
import useMutation from "../../../hooks/useMutation";

const validation = {
  firstName: { required: true, message: "First name is required" },
  lastName: { required: true, message: "Last name is required" },
  email: { required: true, message: "Email is required" },
  //   phone: { required: true, message: "Phone number is required" },
};

function UserProfile({ details, loading, getResponse = () => {} }) {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
  });
  const [viewUserDetails, setViewUserDetails] = useState({});

  useEffect(() => {
    if (details?._id) {
      const { phone, ...rest } = details;
      setFieldsValue({
        ...rest,
        image: details?.image?.url,
        phone: {
          number: phone?.number || "",
          countryCode: phone?.countryCode || "",
          fullNumber: phone?.fullNumber || "",
        },
      });
    }
  }, [details]);

  const {
    mutate: onSubmit,
    error,
    isPending: isLoading,
  } = useMutation({
    // mutationFn: async (val) => {
    //   return await userAddEdit({
    //     ...val,

    //     // roleCode: "USER",
    //     role: "user",
    //     ...(details?._id && { id: details?._id }),
    //   });
    // },
    mutationFn: async (val) => {
      const base = {
        image: val.image,
        firstName: val.firstName,
        lastName: val.lastName,
        phone: {
          countryCode: val.phone?.countryCode || "",
          number: val.phone?.number || "",
          fullNumber: val.phone?.fullNumber || "",
        },
      };

      const payload = !details?._id
        ? {
            ...base,
            email: val.email,
            role: "user",
          }
        : {
            ...base,
            id: details?._id,
            role: "user",
          };

      return await userAddEdit(payload);
    },
    onSuccess: (res) => {
      getResponse(res);
      //     if (res?.status === 200 || res?.status === 201) {
      //     resetField();
      //   }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  //   console.log(details);

  return (
    <Form
      onSubmit={onSubmit}
      handleSubmit={handleSubmit}
      //  loading={loading}
    >
      <div className="flex px-6 py-4 flex-wrap md:flex-nowrap gap-6 items-start">
        <div className="w-full md:w-2/4 flex-shrink-0 flex items-center justify-center">
          <AvatarUpload
            src={
              values?.image instanceof File
                ? URL.createObjectURL(values?.image)
                : values?.image
            }
            onChange={(file) => {
              handleChange({ target: { name: "image", value: file } });
            }}
            alt="profile"
            initial={initialsValue(
              details?.firstName + " " + details?.lastName
            )}
          />
        </div>

        <div className="w-full md:w-2/4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 text-sm text-gray-700">
            <div className="flex flex-col gap-3">
              <p className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-gray-500"></i>
                {details?.email || "N/A"}
              </p>
              <p className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-gray-500"></i>
                {/* {(details?.phone?.countryCode || "").replace("+", "")}{" "} */}
                {`${details?.phone?.countryCode || ""} ${
                  details?.phone?.number || ""
                }`.trim() || "N/A"}
              </p>
              <p className="flex items-center gap-3">
                <i className="fa-solid fas fa-user  text-gray-500"></i>

                {`${details?.firstName || ""} ${
                  details?.lastName || ""
                }`.trim() || "-"}
              </p>
            </div>

            <div className="flex flex-col gap-3 items-start">
              <Badge
                type={details?.status === 1 ? "success" : "danger"}
                label={details?.status === 1 ? "Active" : "Inactive"}
              />

              <p className="flex items-center gap-3">
                <i className="fa-solid fa-calendar  text-gray-500"></i>

                {dayjs(details?.createdAt).format("DD MMM, YYYY") || "-"}
              </p>
              <p className="flex items-center gap-3">
                <i className="fa-solid  fa-user  text-gray-500"></i>

                {details?.socialAccounts?.[0]?.providerId || "Not Auth0 User"}
              </p>
            </div>
          </div>
        </div>
      </div>

      <Cards
        title="Basic information"
        description="This section includes essential details and other personal identifiers that help establish your identity."
      >
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <Input
              label={"First Name"}
              inputPlaceholder="Enter first name"
              onChange={handleChange}
              inputName={"firstName"}
              required={false}
              value={values?.firstName}
              {...formValidate(errors, "firstName")}
            />

            <Input
              label={"Last Name"}
              inputPlaceholder="Enter last name"
              inputName={"lastName"}
              value={values?.lastName}
              onChange={handleChange}
              {...formValidate(errors, "lastName")}
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Input
              label="Email"
              inputPlaceholder="Enter Email"
              inputType="email"
              inputName="email"
              value={values?.email}
              isDisabled={details?._id}
              onChange={handleChange}
              {...formValidate(errors, "email")}
            />
            <div className="grid grid-cols-3 gap-3">
              <Input
                label="Country Code"
                inputPlaceholder="e.g:- +91"
                inputName="phone.countryCode"
                value={values?.phone?.countryCode || ""}
                onChange={(e) => {
                  const countryCode = e.target.value.trim();
                  const fullNumber = `${countryCode}${
                    values?.phone?.number || ""
                  }`;
                  handleChange({
                    target: {
                      name: "phone",
                      value: {
                        ...values?.phone,
                        countryCode,
                        fullNumber,
                      },
                    },
                  });
                }}
              />

              <div className="col-span-2">
                <Input
                  label="Phone Number"
                  inputPlaceholder="e.g:- 9876543210"
                  inputName="phone.number"
                  value={values?.phone?.number || ""}
                  onChange={(e) => {
                    const number = e.target.value.trim();
                    const fullNumber = `${
                      values?.phone?.countryCode || ""
                    }${number}`;
                    handleChange({
                      target: {
                        name: "phone",
                        value: {
                          ...values?.phone,
                          number,
                          fullNumber,
                        },
                      },
                    });
                  }}
                  {...formValidate(errors, "phone")}
                />
              </div>
            </div>
          </div>
        </div>
      </Cards>

      <div className="pt-3 gap-4 pb-6 flex justify-end">
        <Button
          buttonType="submit"
          buttonLabel={details?._id ? "Update User" : "Save User"}
          buttonClasses="!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
          buttonLabelClasses="mx-auto"
          {...(isLoading && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
        {/* <Button
          buttonLabel="Cancel"
          buttonFunction={close}
          buttonClasses="!rounded-full !px-8 !h-12 !border !border-gray-400 !bg-transparent !text-gray-600 hover:!bg-gray-200"
          buttonLabelClasses="mx-auto"
        /> */}
      </div>
    </Form>
  );
}

export default UserProfile;
